export default "\n\n    <app-payment-list></app-payment-list>\n\n";